import { IconSun, IconMoon } from "@tabler/icons-react";
import { useTheme } from "../hooks/useTheme.ts";

export function ThemeToggle() {
	const { theme, toggle } = useTheme();
	const isDark = theme === "dark";
	return (
		<button
			type="button"
			className="btn btn-ghost"
			aria-label={isDark ? "Aktifkan mode terang" : "Aktifkan mode gelap"}
			aria-pressed={isDark}
			title={isDark ? "Mode terang" : "Mode gelap"}
			onClick={toggle}
			style={{
				width: 38,
				height: 38,
				padding: 0,
				borderRadius: "var(--radius-full)",
				border: "1px solid var(--color-border)",
			}}
		>
			{isDark ? <IconSun size={18} /> : <IconMoon size={18} />}
		</button>
	);
}
